import { AlertPresenter, IAlertOptions } from '../../app/AlertBinder.tsx';
import { EditableMissionState } from '../model/EditableMissionState.ts';
import { DevSettings } from '../../support/DevSettings.ts';

export class LAANCAlert {

    static inject = () => [AlertPresenter, DevSettings];
    constructor(private alert: AlertPresenter, private devSettings: DevSettings) {}

    showAlert = ({ message, mission, ...otherOptions }: IAlertOptions & { mission: EditableMissionState}) => {

        if (!mission.state.isReal && !this.devSettings.disableNotRealWarnings) {
            message = `${message}<br/><br/><i>DISCLAIMER: These authorizations are simulated, and do not provide FAA approval to fly.</i>`;
        }

        return this.alert.showAlert({ message, ...otherOptions });
    };
};
